// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDistributorItem_container__8ViQW"};